import axios from "axios";
import { API } from "./api";

export const PROFILE = "pdv_menu_profile";

export const effPrice = (p) => (Number(p.promo_price) > 0 && Number(p.promo_price) < p.price ? Number(p.promo_price) : p.price);
export const hasPromo = (p) => effPrice(p) < p.price;
export const digits = (v = "") => String(v).replace(/\D/g, "");

const tokenKey = (slug) => `shop_token_${slug}`;
export const shopToken = {
  get: (slug) => localStorage.getItem(tokenKey(slug)),
  set: (slug, t) => localStorage.setItem(tokenKey(slug), t),
  clear: (slug) => localStorage.removeItem(tokenKey(slug)),
};

// Pedidos feitos NESTE aparelho (para "Meus pedidos" sem conta). O servidor só mostra pedidos
// cujo código está aqui e com o mesmo celular — o celular sozinho não basta.
const ordersKey = (slug) => `shop_orders_${slug}`;
export const myOrders = {
  ids: (slug) => { try { return JSON.parse(localStorage.getItem(ordersKey(slug)) || "[]"); } catch (_) { return []; } },
  add: (slug, id) => {
    if (!id) return;
    try { localStorage.setItem(ordersKey(slug), JSON.stringify([id, ...myOrders.ids(slug).filter((x) => x !== id)].slice(0, 30))); } catch (_) { /* sem armazenamento */ }
  },
  query: (slug, phone) => `phone=${encodeURIComponent(phone || "")}&ids=${encodeURIComponent(myOrders.ids(slug).join(","))}`,
};

export function shopApi(slug) {
  const c = axios.create({ baseURL: `${API}/public/menu/${slug}` });
  c.interceptors.request.use((cfg) => {
    const t = shopToken.get(slug);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return c;
}

export const todayIdx = () => (new Date().getDay() + 6) % 7;

export function openInfo(st) {
  const h = st.opening_hours?.[todayIdx()];
  if (st.open_now && h?.enabled) return { open: true, text: `Aberto até às ${h.close.replace(":", "h")}` };
  return { open: false, text: "Fechado no momento" };
}

export function shipInfo(st, ship) {
  if (ship.type === "retirada") return { fee: 0, eta: st.default_eta, ready: true };
  if (st.delivery_area_mode === "mapa") {
    const q = ship.quote;
    return q?.ok ? { fee: q.fee, eta: q.eta || st.default_eta, ready: true, area: q.area } : { fee: 0, eta: st.default_eta, ready: false, blocked: !!q };
  }
  const zones = st.delivery_zones || [];
  const z = zones.find((x) => x.name === ship.zone);
  const ready = !!(ship.addr?.street && ship.addr?.number && (zones.length ? z : ship.addr?.district));
  return { fee: zones.length ? Number(z?.fee || 0) : Number(st.delivery_fee || 0), eta: st.default_eta, ready, area: z?.name };
}

export function loyaltyText(l) {
  const valid = l.expiry_days ? ` Os pontos valem ${l.expiry_days} dias.` : "";
  if (l.mode === "points") {
    const welcome = l.welcome_points ? ` Cadastre-se e ganhe ${l.welcome_points} pontos de boas-vindas.` : "";
    return `A cada R$ 1,00 em compras você ganha ${l.points_per_real} ponto${l.points_per_real === 1 ? "" : "s"}. Troque seus pontos por descontos e produtos grátis.${welcome}${valid}`;
  }
  return `Ganhe ${l.cashback_pct}% de volta em cada compra para usar como desconto nos próximos pedidos.${valid.replace("pontos", "saldo")}`;
}
